import type { SVGProps } from "react";

export function IconWhiteMoneyCash(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M17 37V36C17 31.0294 12.9706 27 8 27H7L7 55H57V27H56C51.0294 27 47 31.0294 47 36V37M47 9V10C47 14.9706 51.0294 19 56 19H57M7 19H8C12.9706 19 17 14.9706 17 10V9M57 49H7M57 43H7M7 9H57V37H7V9ZM41 23C41 30.732 36.9706 37 32 37C27.0294 37 23 30.732 23 23C23 15.268 27.0294 9 32 9C36.9706 9 41 15.268 41 23Z"
        stroke="#23232C"
        strokeWidth="1.5"
      />
    </svg>
  );
}
